import axios from 'axios'
import { serializeParams } from '../utils/genericUtils.js'

export default {
  namespaced: true,

  actions: {
    deleteImage(_, id) {
      return axios({
        url: process.env.VUE_APP_URL + '/parent/web/deleteImage',
        method: 'DELETE',
        params: {
          id,
        },
      })
    },
    getTutors(_, filters) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/parent/web/getbybranch${serializeParams(filters)}`,
        method: 'GET',
      })
    },
    getTutorsFilters() {
      return axios({
        url: `${process.env.VUE_APP_URL}/parent/web/getbybranch/filters`,
        method: 'GET',
      })
    },
    getTutorsImages(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/parent/getImageWeb?id=' + id,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    createTutor({ rootGetters }, parent) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/parent/web/create?id=' +
            rootGetters.getBranch.id,
          data: parent,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error.response.data)
          })
      })
    },
    updateTutor({ rootGetters }, parent) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/parent/web/update',
          data: parent,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error.response.data)
          })
      })
    },
    deleteTutors(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/parent/web/deleteV2',
          data: obj,
          method: 'DELETE',
        })
          .then((response) => {
            if (response) {
              resolve(response)
            }
            reject(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getLevelsParentTool() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/parent/web/tool',
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getLevelsExtraTool() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/parent/web/toolregister',
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addChildToParent(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/parent/web/addstudenttoparent?pid=' +
            obj.pid +
            '&sid=' +
            obj.sid,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    resendEmail(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/parent/web/resendEmail',
          data: obj,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    resendEmailV2(_, data) {
      return axios({
        url: `${process.env.VUE_APP_URL}/parent/web/resendEmailV2`,
        data,
        method: 'POST',
      })
    },
    getAllWithNoChildren({ rootGetters }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/parent/web/getall?id=' +
            rootGetters.getBranch.id,

          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    removeChildToParents(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/parent/web/removeStudentToParent?&idS=' +
            obj.sid,
          data: obj.pars,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getParentCars(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/Cars/web/getbyparent?id=' + id,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getParentFamiliars(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/parent/web/getfamqrs?id=' + id,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    generateFamiliarQr(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/parent/web/famqrgen',
          data: obj,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getQr(_, filters) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${process.env.VUE_APP_URL}/parent/web/qr${serializeParams(
          filters
        )}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    getParentsByBranchToCsv(_, filters) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/parent/web/exportParentsXlsx${serializeParams(filters)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    getParentsStudentsByBranchToCsv(_, filters) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `
          ${
            process.env.VUE_APP_URL
          }/parent/web/exportParentWithStudentsXlsx${serializeParams(filters)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    getThirdQr(o) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/parent/web/getAllThQR',
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getChofers(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/chofer/web/byParent?id=' + id,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    blockQR(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/parent/web/' + obj.id + '/toggleQR',
          data: {
            reason: obj.reason,
            disable: obj.disable,
            start: obj.start,
            end: obj.endDate,
          },
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getToAssignToStudents({ rootGetters }, query) {
      return new Promise((resolve, reject) => {
        axios({
          url: `${process.env.VUE_APP_URL}/parent/web/toAssignToStudent?${query}`,
          method: 'GET',
        })
          .then((response) => {
            if (response.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    /**
     *
     * @param {*} _
     * @param {{id:string, data}}  ID del tutor al que se le va a agregar el chofer.
     */
    addDriver(_, { id, data }) {
      return axios({
        url: `${process.env.VUE_APP_URL}/chofer/web/${id}`,
        method: 'POST',
        data,
      })
    },
    /**
     *
     * idOwner - Indica el tutor al que se le va a remover el chofer.
     *
     * idDriver - Indica el chofer que se va a eliminar.
     * @param {*} _
     * @param {{idOwner:string, idDriver}}
     */
    deleteDriver(_, { idOwner, idDriver }) {
      return axios({
        url: `${process.env.VUE_APP_URL}/chofer/web/${idOwner}/${idDriver}`,
        method: 'DELETE',
      })
    },
    updateDriver(_, { idDriver, data }) {
      return axios({
        url: `${process.env.VUE_APP_URL}/chofer/web/${idDriver}`,
        method: 'PUT',
        data,
      })
    },
  },
}
